module.exports = __webpack_public_path__ + "img/icone-money.412a55ae.svg";